import * as ko from 'knockout';

interface BodyPart {
  partType: string;
  text: string;
  href: string;
}

export default class BodyTextBindable {

  public readonly parts: ko.Observable<BodyPart[]>;
  public readonly htmlText: ko.Computed<string>;

  private readonly _htmlEscapePattern: RegExp = /[&<>"'`=\/]/g;
  private readonly _htmlEscapeMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;',
      '`': '&#x60;',
      '=': '&#x3D;'
  };

  constructor(parts: BodyPart[]) {
      this.parts = ko.observable(parts);
      this.htmlText = ko.computed(this._CalculateHtml, this);
      
  }

  private _CalculateHtml(): string {
      let htmlString = "<p>";
      this.parts().forEach(part => {

          if ("text" == part.partType) {
              htmlString += this._escapeHtml(part.text);
          }
          else if ("link" == part.partType) {
              htmlString += "<a href=\"" + part.href + "\">" + this._escapeHtml(part.text) + "</a>";
          }
          else if ("infinityCallTrackingNumber" == part.partType) {
              htmlString += '<span class="InfinityNumber clickable">+441454662127</span>';
          }
          else if ("paragraphBreak" == part.partType) {
              htmlString += "</p><p>";
          }

      });

      htmlString += "</p>";
      return htmlString;
  }

  private _escapeHtml(raw: string) {
      return raw.replace(this._htmlEscapePattern, (m) => this._htmlEscapeMap[m])
  }

}